var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
import { throwError, DEPRECATE, isObject } from './utils';
import { Primitive } from 'function-tree';
import { Compute } from './Compute';
import { Reaction } from './Reaction';
var Module = function () {
  function Module(moduleDescription) {
    _classCallCheck(this, Module);
    this.moduleDescription = moduleDescription;
  }
  _createClass(Module, [{
    key: 'create',
    value: function create(controller, path) {
      var stringPath = path.join('.');
      var moduleStub = {
        app: controller,
        path: stringPath,
        name: path.slice().pop()
      };
      var module = typeof this.moduleDescription === 'function' ? this.moduleDescription(moduleStub) : Object.assign({}, this.moduleDescription);
      function initializeComputed(object, nestedPath) {
        Object.keys(object).forEach(function (key) {
          if (typeof object[key] === 'function') {
            object[key] = new Compute(object[key]).create(controller, path, path.concat(nestedPath, key).join('.'));
          } else if (object[key] instanceof Compute) {
            object[key].create(controller, path, path.concat(nestedPath, key).join('.'));
          } else if (isObject(object[key])) {
            initializeComputed(object[key], nestedPath.concat(key));
          }
          if (controller.devtools && object[key] instanceof Compute) {
            controller.devtools.registerComputedState(object[key], path.concat(nestedPath, key));
          }
        });
      }
      initializeComputed(module.state || {}, []);

      /* Convert arrays to actually runable sequences */
      if (module.signals) {
        DEPRECATE('module.signals', 'use the property "sequences" when adding sequences to a module');
      }
      var sequences = module.sequences || module.signals;
      module.sequences = Object.keys(sequences || {}).reduce(function (currentSequences, sequenceKey) {
        var sequence = sequences[sequenceKey];
        if (!(sequence && (Array.isArray(sequence) || typeof sequence === 'function' || sequence instanceof Primitive))) {
          throwError('Sequence with name "' + sequenceKey + '" is not correctly defined. Please check that the sequence is either a sequence, an array or a function.');
        }
        currentSequences[sequenceKey] = {
          sequence: sequence,
          run: function run(payload) {
            return controller.runSequence(path.concat(sequenceKey).join('.'), sequence, payload);
          }
        };
        return currentSequences;
      }, {});

      /* Instantiate submodules */
      module.modules = Object.keys(module.modules || {}).reduce(function (registered, moduleKey) {
        var subModule = module.modules[moduleKey] instanceof Module ? module.modules[moduleKey] : new Module(module.modules[moduleKey]);
        registered[moduleKey] = subModule.create(controller, path.concat(moduleKey));
        return registered;
      }, {});

      /* Instantiate watcher */
      module.reactions = Object.keys(module.reactions || {}).reduce(function (registered, reactionKey) {
        if (!(module.reactions[reactionKey] instanceof Reaction)) {
          throw new Error('You are not using a Reaction in module on key "' + reactionKey + '"');
        }
        registered[reactionKey] = module.reactions[reactionKey].create(controller, path, path.concat(reactionKey).join('.'));
        return registered;
      }, {});
      return module;
    }
  }]);
  return Module;
}();
export default Module;